import { THEME_NAMES, ThemeName } from '@/hero';
import { useAppContext } from '@/providers/app-provider/app-provider';
import { resolveThemeColor } from '@/utils/theme-colors';

type StudioContext = {
  isStudioPreview?: boolean;
  studioTheme?: string;
  coreConfig?: {
    theme?: string;
  };
};

export function useResolveThemeColor() {
  const { isStudioPreview, studioTheme, coreConfig } = useAppContext<StudioContext>();
  const activeTheme = isStudioPreview ? studioTheme : coreConfig?.theme;
  const theme: ThemeName = THEME_NAMES.includes(activeTheme as ThemeName)
    ? (activeTheme as ThemeName)
    : 'bndk';

  return (value: string | undefined | null) => resolveThemeColor(value, theme);
}
